import { render } from "./dealer_setup.vue?vue&type=template&id=46a6dad7"
import script from "./dealer_setup.vue?vue&type=script&lang=js"
export * from "./dealer_setup.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__